import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { FloatingLabel, Form } from "react-bootstrap";
import { appSendRegisterOtp } from "../../services/AuthServices";
import { registerWithOtp } from "../../store/actions/authActions";
import { PLEASE_WAIT_TXT } from "../../utils/Constant";

/**
 * BOC
 * API Security - Step 4 OTP login / signup UI
 * date 23-10-2026
 * use_of_code: Signup OTP screen. The account is created by appRegisterUser only after the OTP is verified on the
 * server. isCheckout changes the button text to "VERIFY OTP & CHECKOUT".
 */
function SignupOTP({
  active,
  otpResponse,
  signupData,
  onSignupSuccess,
  isCheckout = false,
}) {
  const [counter, setCounter] = useState(otpResponse?.resend_after || 60);
  const [otpToVerify, setOtpToVerify] = useState("");
  const [msg, setMsg] = useState("");
  const [responseData, setResponseData] = useState(otpResponse);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isResending, setIsResending] = useState(false);
  const dispatch = useDispatch();

  useEffect(() => {
    const timer =
      counter > 0 && setInterval(() => setCounter(counter - 1), 1000);
    return () => clearInterval(timer);
  }, [counter]);

  if (!active || !signupData) return null;

  const onVerifyOTPSignup = (e) => {
    e.preventDefault();
    if (!otpToVerify.trim() || isSubmitting) {
      return;
    }
    setIsSubmitting(true);
    setMsg("");
    dispatch(registerWithOtp({ ...signupData, is_validate: 0, otp: otpToVerify.trim() })).then(
      (res) => {
        if (res?.status === "success") {
          onSignupSuccess && onSignupSuccess();
        } else {
          setIsSubmitting(false);
          setMsg(res?.message || "Something went wrong. Please try again.");
        }
      }
    );
  };

  const onResendOtpClick = () => {
    if (counter > 0 || isResending) {
      return;
    }
    setIsResending(true);
    setMsg("");
    appSendRegisterOtp({
      first_name: signupData.first_name,
      email: signupData.email,
      mobile_number: signupData.mobile_number,
    })
      .then((res) => {
        res = JSON.parse(res?.data);
        if (res?.status === "success") {
          setCounter(res?.resend_after || 60);
          setResponseData(res);
          setOtpToVerify("");
        } else {
          setMsg(res?.message || "Something went wrong. Please try again.");
        }
      })
      .finally(() => setIsResending(false));
  };

  return (
    <Form onSubmit={onVerifyOTPSignup} noValidate autoComplete="off">
      <p className="otp-sent-text mb-4">{responseData?.message}</p>
      <FloatingLabel controlId="signup_otp" label="Enter OTP" className="mb-3">
        <Form.Control
          type="text"
          inputMode="numeric"
          maxLength={6}
          name="otp"
          autoComplete="one-time-code"
          placeholder="Enter OTP"
          value={otpToVerify}
          onChange={(e) => setOtpToVerify(e.target.value.replace(/[^0-9]/g, ""))}
        />
      </FloatingLabel>
      {msg.length > 0 ? <span className="text-danger">{msg}</span> : null}
      <button
        type="submit"
        className="btn btn-primary mt-35"
        disabled={isSubmitting || otpToVerify.length < 4}
      >
        {isSubmitting
          ? PLEASE_WAIT_TXT
          : isCheckout
          ? "VERIFY OTP & CHECKOUT"
          : "VERIFY OTP & SIGN UP"}
      </button>
      <p className="mt-15 resend-otp-text">
        Didn't receive an OTP?{" "}
        <button
          className="btn-blank text-underline"
          type="button"
          disabled={counter > 0 || isResending}
          onClick={onResendOtpClick}
          style={{ color: counter > 0 ? "#949494" : "black" }}
        >
          {isResending ? PLEASE_WAIT_TXT : "Resend OTP"}
        </button>
        {counter > 0 && <span className="text-muted"> in {counter}s</span>}
      </p>
    </Form>
  );
}
/**
 * EOC
 */

export default SignupOTP;
